import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

const StationActivitiesRouter = {
  path: '/station_activities',
  component: Management,
  redirect: '/station_activities/list',
  children: [
    {
      path: 'list',
      component: () => import('@/views/station_activities/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listStationActivities
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/station_activities/ListTable'),
          meta: {
            auth: Auth.listStationActivities,
            tabName: 'all'
          }
        }
      ]
    },
    {
      path: 'statistics',
      component: () => import('@/views/station_activities/Statistics'),
      meta: {
        auth: Auth.listStationActivities
      }
    }
  ]
}

export default StationActivitiesRouter
